import { getCompanyId } from "../../../../Auth";

const fetchPayrollReminderSettings = async (api, station) => {
    try {
        const isAllStations = typeof station === "string" && station.includes("-all");

        const params = isAllStations
            ? {
                  actions: {
                      response: {
                          PayrollReminderSettings: {
                              custom: {
                                  functionName: "getCompanyLevelReminderSetting",
                                  get: "payroll_reminder_setting",
                                  criteria: {
                                      stationId: station,
                                  },
                              },
                          },
                      },
                  },
              }
            : {
                  actions: {
                      response: {
                          PayrollReminderSettings: {
                              findBy: {
                                  get: "payroll_reminder_setting",
                                  criteria: {
                                      station,
                                  },
                                  includes: {
                                      0: "settings",
                                  },
                              },
                          },
                      },
                  },
              };

        const { data } = await api.post("/api/lazy/manage/data", params);

        if (!data?.data) {
            return { error: true };
        }

        const result = data?.data?.payroll_reminder_setting;

        if (isAllStations) {
            return result || [];
        }
        return result?.[0] || [];
    } catch (error) {
        console.error("Error fetching payroll reminder settings:", error);
        return { error: true };
    }
};

const savePayrollReminder = async (api, station, settings) => {
    try {
        const params = {
            actions: {
                response: {
                    PayrollReminderSettings: {
                        custom: {
                            functionName: "storePayrollReminderSetting",
                            get: "payrollNotification",
                            criteria: {
                                stationId: station,
                                settings,
                            },
                        },
                    },
                },
            },
        };

        const { data } = await api.post("/api/lazy/manage/data", params);
        return data?.data?.payrollNotification || false;
    } catch (error) {
        console.error("Error storing payroll reminder settings:", error);
        return false;
    }
};

const checkIfAnyPayrollAccountIsActive = async (api) => {
    try {
        const params = {
            actions: {
                response: {
                    PayrollAccount: {
                        findBy: {
                            get: "PayrollAccount",
                            criteria: {
                                enabled: true,
                                isArchive: false,
                                company: getCompanyId()
                            },
                            excludes: {
                                0: "company"
                            },
                            includes: {
                                0: "id",
                                1: "name"
                            }
                        }
                    }
                }
            }
        };

        const { data } = await api.post("/api/lazy/manage/data", params);
        return data?.data?.PayrollAccount?.length > 0 || false;
    } catch (error) {
        console.error("Error getting active payroll account:", error);
        return false;
    }
}

export { savePayrollReminder, fetchPayrollReminderSettings, checkIfAnyPayrollAccountIsActive };
